import {SELECT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: SELECT,
  attribute: 'repo_type',
  label: {
    default: 'Repossession Type',
    short: 'Type',
  },
  options: [
    {key: 'no_repo', label: 'No Repo'},
    {key: 'sally_fleet_retrieval', label: 'Sally Fleet Retrieval'},
    {key: 'towing_service', label: 'Towing Service'},
    {key: 'driver_returned', label: 'Driver Returned'},
  ],
});
